<template>
  <div style="margin-top: 10px;">
    <div style="margin-bottom: 5px;">
      <el-button type="primary" size="small" @click="downLoadTemplate">下载模板</el-button>
      <el-button type="warning" size="small" @click="$router.push('/wordSheet?appCode=ec-pc-new&fileName=说辞表.xlsx')">上传</el-button>
    </div>
    <el-table
      border
      :header-cell-style="{backgroundColor: '#F4F8FB'}"
      :data="tableData"
      :height="tableHeight"
      v-if="tableHeight"
      v-loading="loading"
      :span-method="objectSpanMethod"
      @sort-change="handleSortChange"
    >
      <el-table-column label="图片" width="50px">
        <template slot-scope="scope" v-if="showDetailBtn(scope.row, 0)">
          <el-link :underline="false" type="primary" @click="showDialog(scope.row, 0)">查看</el-link>
        </template>
      </el-table-column>
      <el-table-column label="SPU编码" prop="spuCode" show-overflow-tooltip width="130px"></el-table-column>
      <el-table-column label="SPU名称" prop="spuName" show-overflow-tooltip width="130px"></el-table-column>
      <el-table-column label="SPU品类" prop="spuCategory" show-overflow-tooltip></el-table-column>
      <el-table-column label="SKU编码" prop="skuCode" show-overflow-tooltip width="180px"></el-table-column>
      <el-table-column label="SKU名称" prop="skuName" show-overflow-tooltip width="150px"></el-table-column>
      <el-table-column label="商品定位" prop="goodsLocationName" show-overflow-tooltip></el-table-column>
      <el-table-column label="风格" prop="styleName" show-overflow-tooltip></el-table-column>
      <el-table-column label="上线时间" prop="endTime" show-overflow-tooltip width="120px"></el-table-column>
      <el-table-column label="类别" prop="productTypeName" show-overflow-tooltip width="120px"></el-table-column>
      <el-table-column label="预计上线时间" prop="expOnelineTime" show-overflow-tooltip width="120px"></el-table-column>
      <el-table-column label="更新时间" prop="updateDate" show-overflow-tooltip width="160px" sortable="custom"></el-table-column>
      <el-table-column label="操作" width="100px" fixed="right">
        <template slot-scope="scope">
          <el-button type="text" @click="importProduct(scope.row)" v-if="!scope.row.isDownload">上传</el-button>
          <template v-else>
            <el-button type="text" @click="showPreView(scope.row)">预览</el-button>
            <el-button type="text" @click="downLoadRequest(scope.row.spuId, scope.row.excuseFile.id, scope.row.excuseFile.name)">下载</el-button>
          </template>
<!--          <el-button type="text" @click="importProduct(scope.row)">上传</el-button>-->
        </template>
      </el-table-column>
    </el-table>
    <div style="text-align: right; margin-top: 10px;">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="paginationOpt.pageNum"
        :page-sizes="paginationOpt.pageSizes"
        :page-size="paginationOpt.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="paginationOpt.total">
      </el-pagination>
    </div>
    <!-- 视频、图片查看 -->
    <pic-video v-model="picVideoVisible" :data="rowData" :detailType="viewType" v-if="picVideoVisible"></pic-video>
    <!-- 导入导出 -->
    <import-export ref="importExport" @onsuccess="init"></import-export>
    <!-- 预览 -->
    <pre-view :visible.sync="preViewVisible" v-if="preViewVisible" :spuId="viewData.spuId" :fileId="viewData.excuseFile.id"></pre-view>
    <!-- 模板下载 -->
    <downLoad-template v-model="downLoadTemplateVisible" v-if="downLoadTemplateVisible"></downLoad-template>
  </div>
</template>

<script>

import picVideoMxin from './pic&video.mixin'
import importExportMxin from './import&export.mixin'

import preView from '../../productInfomation/preview'
import downLoadTemplate from './download'
export default {
  mixins: [ picVideoMxin, importExportMxin],
  components: { preView, downLoadTemplate },
  props: ['tableHeight'],
  data() {
    return {
      loading: false,
      viewData:{},
      formData: {},
      tableData: [],
      paginationOpt: {
        pageSizes: [30, 60, 90],
        pageSize: 30,
        pageNum: 1,
        total: 0
      },
      preViewVisible: false,
      downLoadTemplateVisible: false,
      updateTimeOrder: ''
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    handleSearch(data) {
      this.paginationOpt.pageNum = 1;
      this.formData = data;
      this.init();
    },
    init() {
      this.loading = true;
      let formData = {
        pageSize: this.paginationOpt.pageSize,
        pageNum: this.paginationOpt.pageNum,
        filterData: {
          ...this.formData,
          updateTimeOrder: this.updateTimeOrder
        }
      };
      this.$q.newProduct.queryExcuseSpuList({data: formData})
      .then(res=>{
        let tableData = [];
        res.data.records.forEach(item=>{
          let spuItem = JSON.parse(JSON.stringify(item));
          delete spuItem['skuList'];
          if(item.skuList && item.skuList.length) {
            item.skuList.forEach((e, i)=>{
              tableData.push({
                ...spuItem,
                ...e,
                dataId: spuItem.dataId,
                skuLength: i === 0 ? item.skuList.length : null
              })
            })
          }else{
            tableData.push({
              ...spuItem,
              skuLength: 1
            })
          }
        });
        this.tableData = tableData;
        this.paginationOpt['total'] = res.data.total;
      })
      .finally(_=>{
        this.loading = false;
      })
    },
    // 分页器 pagesize
    handleSizeChange(val) {
      this.paginationOpt.pageSize = val;
      this.paginationOpt.pageNum = 1;
      this.init();
    },
    // 分页器 pageNum
    handleCurrentChange(val) {
      this.paginationOpt.pageNum = val;
      this.init();
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if(columnIndex < 4 || columnIndex > 8) {
        if(row.skuLength) {
          return {
            rowspan: row.skuLength,
            colspan: 1
          }
        } else {
          return {
            rowspan: 0,
            colspan: 0
          }
        }
      }
    },
    showPreView(data) {
      this.viewData = data
      this.preViewVisible = true;
    },
    /**
     * 下载
     */
    downLoadRequest(spuId, fileId, fileName) {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      this.$q.newProduct.downLoadExcuseExcel({
        data: {
          fileId: fileId,
          spuId: spuId
        },
        options: {
          responseType: 'blob'
        }
      })
      .then(res=>{
        this.blobDownload(res, fileName)
      })
      .finally(_=>{
        loading.close();
      })
    },
    /**
     * 下载模板
     */
    // 获取导入模板
    downLoadTemplate() {
      this.downLoadTemplateVisible = true;
    },
    // 排序
    handleSortChange({ column, prop, order }) {
      this.updateTimeOrder = order === 'ascending' ? 'ASC' : order === 'descending' ? 'DESC' : ''
      this.init();
    }
  }
}
</script>
<style lang="stylus" scoped>
</style>
